/**
 * Styled components for VehicleInformationStep
 */
import styled from 'styled-components';
import { Button, Input, Select, DatePicker, Table, Modal } from 'antd';
import { Box, Text } from 'atoms';

export const HeaderContainer = styled(Box)`
	display: flex;
	justify-content: space-between;
	align-items: center;
	margin-bottom: 24px;
`;

export const SectionTitle = styled(Text)`
	font-size: 18px;
	font-weight: 600;
	color: #1c1c1c;
`;

export const BulkUploadButton = styled(Button)`
	background-color: #fff;
	color: #18405d;
	border: 1px solid #18405d;
	border-radius: 4px;
	padding: 8px 20px;
	height: auto;
	font-size: 14px;
	font-weight: 500;
	display: flex;
	align-items: center;
	gap: 8px;

	&:hover {
		background-color: #f0f5f9 !important;
		color: #18405d !important;
		border-color: #18405d !important;
	}
`;

export const StyledInput = styled(Input)`
	border-radius: 4px;
	font-size: 14px;
	padding: 8px 12px;

	&::placeholder {
		color: #bfbfbf;
		font-size: 13px;
	}

	&:disabled {
		background: #f5f5f5;
		color: #8c8c8c;
		cursor: not-allowed;
	}
`;

export const StyledSelect = styled(Select)`
	width: 100%;

	.ant-select-selector {
		border-radius: 4px;
		font-size: 14px;
		padding: 4px 12px !important;
		height: auto !important;
		min-height: 40px;
	}

	.ant-select-selection-placeholder {
		color: #bfbfbf;
		font-size: 13px;
	}
`;

export const StyledDatePicker = styled(DatePicker)`
	width: 100%;
	border-radius: 4px;
	font-size: 14px;
	padding: 8px 12px;

	.ant-picker-input > input::placeholder {
		color: #bfbfbf;
		font-size: 13px;
	}
`;

export const BrowseButton = styled(Button)`
	background-color: #18405d;
	color: #fff;
	border: none;
	border-radius: 4px;
	padding: 8px 20px;
	height: 40px;
	font-size: 14px;
	font-weight: 500;
	display: flex;
	align-items: center;
	gap: 8px;

	&:hover {
		background-color: #153e60 !important;
		color: #fff !important;
	}
`;

export const LightBrowseButton = styled(Button)`
	background-color: ##18405d;
	color: #fff;
	border: none;
	border-radius: 4px;
	padding: 8px 20px;
	height: 40px;
	font-size: 14px;
	font-weight: 500;
	display: flex;
	align-items: center;
	gap: 8px;

	&:hover {
		background-color: #d9d9d9 !important;
		color: #595959 !important;
	}
`;

export const AddVehicleButton = styled(Button)`
	background-color: #18405d;
	color: #fff;
	border: none;
	border-radius: 4px;
	padding: 10px 32px;
	height: auto;
	font-size: 15px;
	font-weight: 500;
	margin-top: 24px;

	&:hover {
		background-color: #153e60 !important;
		color: #fff !important;
	}
`;

export const StyledTable = styled(Table)`
	margin-top: 40px;

	.ant-table-thead > tr > th {
		background-color: #18405d;
		color: #fff;
		font-weight: 600;
		font-size: 14px;
		padding: 12px 16px;
		border: none;
	}

	.ant-table-tbody > tr > td {
		padding: 12px 16px;
		font-size: 14px;
		color: #1c1c1c;
	}

	.ant-table-tbody > tr:hover > td {
		background-color: #f5f5f5;
	}
`;

export const ViewButton = styled(Button)`
	background: none;
	border: none;
	padding: 4px;
	height: auto;
	color: #18405d;
	cursor: pointer;
	display: flex;
	align-items: center;
	justify-content: center;

	&:hover {
		color: #153e60 !important;
		background: none !important;
	}
`;

export const DocumentPreviewIcon = styled.div`
	display: inline-flex;
	align-items: center;
	justify-content: center;
	width: 32px;
	height: 32px;
	background: #e6f7ff;
	border: 1px solid #91d5ff;
	border-radius: 4px;
	cursor: pointer;
	color: #1890ff;
	font-size: 16px;
	transition: all 0.3s;

	&:hover {
		background: #bae7ff;
		border-color: #1890ff;
		transform: scale(1.1);
	}
`;

export const PendingDocumentStatus = styled.div`
	display: inline-flex;
	align-items: center;
	gap: 6px;
	color: #f59e0b;
	font-size: 12px;
	font-weight: 600;
	text-transform: uppercase;
`;

export const StyledModal = styled(Modal)`
	.ant-modal-header {
		border-bottom: 1px solid #e0e0e0;
		padding: 16px 24px;
	}

	.ant-modal-title {
		font-size: 18px;
		font-weight: 600;
		color: #1c1c1c;
	}

	.ant-modal-body {
		padding: 24px;
		max-height: 70vh;
		overflow-y: auto;
	}

	.ant-modal-footer {
		border-top: 1px solid #e0e0e0;
		padding: 16px 24px;
		display: flex;
		justify-content: space-between;
	}
`;

export const RemoveButton = styled(Button)`
	color: #ff4d4f;
	border: 1px solid #ff4d4f;
	background: #fff;
	border-radius: 4px;
	padding: 8px 24px;
	height: auto;
	font-size: 14px;
	font-weight: 500;

	&:hover {
		color: #fff !important;
		background-color: #ff4d4f !important;
		border-color: #ff4d4f !important;
	}
`;

export const SaveButton = styled(Button)`
	background-color: #18405d;
	color: #fff;
	border: none;
	border-radius: 4px;
	padding: 8px 24px;
	height: auto;
	font-size: 14px;
	font-weight: 500;

	&:hover {
		background-color: #153e60 !important;
		color: #fff !important;
	}
`;

export const FilePreview = styled(Box)`
	display: flex;
	align-items: center;
	gap: 8px;
	padding: 8px 12px;
	background: #f5f5f5;
	border-radius: 4px;
	margin-top: 8px;
`;

export const FileIcon = styled.span`
	color: #ff4d4f;
	font-size: 16px;
`;

export const FileName = styled(Text)`
	flex: 1;
	font-size: 13px;
	color: #1c1c1c;
`;

export const FileSize = styled(Text)`
	font-size: 12px;
	color: #8c8c8c;
`;

export const RemoveFileButton = styled(Button)`
	background: none;
	border: none;
	padding: 0;
	color: #8c8c8c;
	cursor: pointer;
	font-size: 18px;
	line-height: 1;

	&:hover {
		color: #ff4d4f !important;
	}
`;

export const ConsentLetterBrowseButton = styled(Button)`
	background-color: #18405d;
	color: #fff;
	border: none;
	border-radius: 4px;
	padding: 8px 20px;
	height: 40px;
	font-size: 14px;
	font-weight: 500;
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 8px;
	width: 100%;

	&:hover {
		background-color: #d9d9d9 !important;
		color: #595959 !important;
	}
`;
